import React, { ReactElement } from "react";
import styled from "styled-components";
import { constants } from "@thecb/components";

interface TableProps {
  extraStyles?: string;
}

export const Table = styled.table<TableProps>`
  width: 100%;
  table-layout: auto;
  ${({ extraStyles }) => extraStyles}
`;

interface TrProps {
  extraStyles?: string;
  hoverEffect?: boolean;
}
const Tr = styled.tr<TrProps>`
  &:not(:last-child) {
    border-bottom: 1px solid ${constants.colors.GHOST_GREY};
  }

  ${({ hoverEffect }) =>
    hoverEffect &&
    `&:hover {
    cursor: pointer;
    background-color: ${constants.colors.HOVER_LIGHT_BLUE};
  }`}

  ${({ extraStyles }) => extraStyles}
`;

const Thead = styled.thead`
  background-color: ${constants.colors.ALABASTER_WHITE};
  border-bottom: 1px solid ${constants.colors.GHOST_GREY};
  font-size: 0.875rem;
`;

interface TableHeaderProps {
  children?: ReactElement[];
  extraStyles?: string;
}
export const TableHeader = ({ children, extraStyles = "" }: TableHeaderProps) => (
  <Thead>
    <Tr extraStyles={extraStyles}>{children}</Tr>
  </Thead>
);

interface TableHeadingProps {
  extraStyles?: string;
  padding?: string;
}
export const TableHeading = styled.th<TableHeadingProps>`
  padding: ${({ padding }) => padding || "16px 24px"};
  min-width: 100px;
  &:last-child {
    text-align: right;
  }
  ${({ extraStyles }) => extraStyles}
`;

interface TableBodyProps {
  extraStyles?: string;
}
export const TableBody = styled.tbody<TableBodyProps>`
  ${({ extraStyles }) => extraStyles}
`;

interface TableRowProps {
  children: ReactElement[];
  onClick: () => void;
  extraStyles?: string;
  setNodeRef?: (node: HTMLElement | null) => void;
}
export const TableRow = ({
  children,
  onClick,
  extraStyles,
  setNodeRef,
  ...props
}: TableRowProps) => (
  <Tr
    ref={setNodeRef}
    onClick={onClick}
    hoverEffect
    {...props}
    extraStyles={extraStyles}
  >
    {children}
  </Tr>
);

interface TableRowEntryProps {
  padding?: string;
  minWidth?: string;
  maxWidth?: string;
  extraStyles?: string;
}

export const TableRowEntry = styled.td<TableRowEntryProps>`
  padding: ${({ padding }) => (padding ? padding : "16px 24px")};
  font-size: 0.875rem;
  white-space: nowrap;
  min-width: ${({ minWidth }) => (minWidth ? minWidth : "75px")};
  max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : "250px")};
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ extraStyles }) => extraStyles};
`;
